import { NSARouterMakerResult } from "namirasoft-account-react";
import { PlatformRow } from "namirasoft-job-arranger";
import { NSCard, NSRow, NSSection } from "namirasoft-site-react";
import { Component } from "react";
import { JobArrangerLayout } from "../JobArrangerLayout";
import { JobArrangerMenus } from "../JobArrangerMenus";
import { JobArrangerProps } from "../JobArrangerProps";
import Styles from "./PlatformListPage.module.css";

interface PlatformListPageProps extends NSARouterMakerResult, JobArrangerProps { }

interface PlatformListPageState
{
    platforms: PlatformRow[];
}

export default class PlatformListPage extends Component<PlatformListPageProps, PlatformListPageState>
{
    constructor(props: PlatformListPageProps)
    {
        super(props);
        this.state = { platforms: [] };
    }
    override async componentDidMount()
    {
        try
        {
            let platforms = await this.props.servers.job_arranger.platform.List();
            this.setState({ platforms });
        }
        catch { }
    }
    override render()
    {
        return (
            <JobArrangerLayout
                {...this.props}
                action={{
                    title: "Platforms",
                    description: "Job platforms supported by Job Arranger for tracking and organizing your job applications.",
                    menus: { "Store": [JobArrangerMenus.download()] }
                }}
            >
                <NSSection>
                    <NSRow classList={[Styles.row]}>
                        {
                            this.state.platforms.map(platform => (
                                <NSCard
                                    key={platform.name}
                                    title={platform.name}
                                    image={{ src: platform.icon, alt: platform.name }}
                                    link={{ href: platform.search, target: "_blank" }}
                                    classList={[Styles.platform_card]}
                                />
                            ))
                        }
                    </NSRow>
                </NSSection>
            </JobArrangerLayout>
        );
    }
}